import GuestOrderPanel from "./GuestOrderPanel.vue";

/**
 * Panel sa detaljima narudžbe za ekrane izveštaja gostiju (narudžbe, prihodi). Ekran mora da ima
 * `changeOrderStatus(order, guest, newStatus)` i `changingStatusOrderId` (iz starog taba).
 * Komponenta detalja je opcija ekrana `panelComponent` (podrazumevano panel sa desne strane).
 */
export default {
  inject: {
    shell: { from: "reportShell", default: null },
  },
  computed: {
    /** Broj narudžbe čiji je panel otvoren (red u tabeli se označava) */
    activeId() {
      const top = this.shell?.panelStack?.[0];
      const match = top && /^order-(.+)$/.exec(top.key);
      return match ? Number(match[1]) : null;
    },
  },
  methods: {
    openOrder(order, guest, event) {
      this.$emit("open-panel", {
        opener: event?.currentTarget,
        key: `order-${order.id}`,
        root: true,
        title: `${this.$t("makeOrder")} #${order.id}`,
        subtitle: `${this.toLatin(guest.name || "")} ${this.toLatin(guest.lastname || "")}`.trim(),
        component: this.$options.panelComponent || GuestOrderPanel,
        props: { order, guest, owner: this },
      });
    },
  },
};
